/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { InlineEdit } from "../../components/InlineEdit";
import { Button } from "../../components/Button";
import { useParams } from "react-router-dom";
import useSaveTemplate from "../../utils/customHooks";
import { SpinnerOverlay } from "../../utils/SpinnerOverlay";

// KD04 — KD57200 WHITE dzieci 223x300 mm
// Pozycje tekstów (style inline, w mm):
//   top   = górna krawędź pola tekstowego
//   left  = środek tekstu (textAlign center + translateX(-50%)) albo lewa krawędź (textAlign left)
//   right = prawa krawędź pola (textAlign right)
// maxWidthN = maks. szerokość tekstu w px — dłuższy tekst zmniejsza czcionkę.
// Uwaga: lineHeight w stylu InlineEdit nie działa (nadpisuje go `font: inherit`), zawsze wynosi 1.5.
export const Kd04: React.FC = () => {
  const { pdfNameFromUrl } = useParams<{ pdfNameFromUrl: string }>();
  const [text1, setText1] = useState<string>("Ignacy");
  const [text2, setText2] = useState<string>("19.07.2023");
  const [text3, setText3] = useState<string>("środa");
  const [text4, setText4] = useState<string>("godz. 12:20");
  const [text5, setText5] = useState<string>("56 cm szczęścia");
  const [text6, setText6] = useState<string>("2590 g miłości");
  const text1BasicSize = 169;
  const text2BasicSize = 40;
  const text3BasicSize = 32;
  const text4BasicSize = 32;
  const text5BasicSize = 32;
  const text6BasicSize = 32;
  const [fontSizeText1, setFontSizeText1] = useState<number>(text1BasicSize);
  const [fontSizeText2, setFontSizeText2] = useState<number>(text2BasicSize);
  const [fontSizeText3, setFontSizeText3] = useState<number>(text3BasicSize);
  const [fontSizeText4, setFontSizeText4] = useState<number>(text4BasicSize);
  const [fontSizeText5, setFontSizeText5] = useState<number>(text5BasicSize);
  const [fontSizeText6, setFontSizeText6] = useState<number>(text6BasicSize);
  const { saveTemplate, isSaving } = useSaveTemplate();

  const pdfWidth = "223mm"; // PDF width in mm
  const pdfHeight = "300mm"; // PDF height in mm
  const font1 = "VeryBerryPro";
  const font2 = "Lato-Regular";
  const maxWidth1 = 563;
  const maxWidth2 = 282;
  const maxWidth3 = 155;
  const maxWidth4 = 239;
  const maxWidth5 = 310;
  const maxWidth6 = 286;

  const adjustFontSize = (
    text: string,
    currentFontSize: number,
    maxFontSize: number,
    minFontSize: number,
    fontFamily: string,
    maxWidth: number,
  ) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (context) {
      let newFontSize = currentFontSize;
      context.font = `${newFontSize}px ${fontFamily}`;
      let textWidth = context.measureText(text).width;

      while (textWidth > maxWidth && newFontSize > minFontSize) {
        newFontSize -= 1;
        context.font = `${newFontSize}px ${fontFamily}`;
        textWidth = context.measureText(text).width;
      }

      while (textWidth < maxWidth * 0.9 && newFontSize < maxFontSize) {
        newFontSize += 1;
        context.font = `${newFontSize}px ${fontFamily}`;
        textWidth = context.measureText(text).width;
      }

      return newFontSize;
    }

    return currentFontSize;
  };

  // Czekamy na załadowanie fontu, inaczej canvas mierzy tekst fontem zastępczym.
  const ensureFont = (fontFamily: string) =>
    document.fonts.load(`1em ${fontFamily}`);

  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText1(
        adjustFontSize(
          text1,
          fontSizeText1,
          text1BasicSize,
          14,
          font1,
          maxWidth1,
        ),
      ),
    );
  }, [text1]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText2(
        adjustFontSize(
          text2,
          fontSizeText2,
          text2BasicSize,
          14,
          font2,
          maxWidth2,
        ),
      ),
    );
  }, [text2]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText3(
        adjustFontSize(
          text3,
          fontSizeText3,
          text3BasicSize,
          10,
          font2,
          maxWidth3,
        ),
      ),
    );
  }, [text3]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText4(
        adjustFontSize(
          text4,
          fontSizeText4,
          text4BasicSize,
          10,
          font2,
          maxWidth4,
        ),
      ),
    );
  }, [text4]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText5(
        adjustFontSize(
          text5,
          fontSizeText5,
          text5BasicSize,
          10,
          font2,
          maxWidth5,
        ),
      ),
    );
  }, [text5]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText6(
        adjustFontSize(
          text6,
          fontSizeText6,
          text6BasicSize,
          10,
          font2,
          maxWidth6,
        ),
      ),
    );
  }, [text6]);

  const handleSave = () => {
    saveTemplate(
      "printable-content",
      {
        pdfWidth: pdfWidth,
        pdfHeight: pdfHeight,
        pdfNameFromUrl: pdfNameFromUrl,
      },
      null,
      false,
    );
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        backgroundColor: "#ffffff",
        padding: "60px",
        position: "relative",
      }}
    >
      {/* Spinner Overlay */}
      <SpinnerOverlay isVisible={isSaving} />
      <div
        style={{
          position: "absolute",
          top: "10px",
          left: "0px",
          right: "0px",
          margin: "auto",
          color: "white",
          width: "150px",
          height: "50px",
        }}
      >
        <Button onClick={handleSave} disabled={isSaving}>
          {isSaving ? "Zapisywanie..." : "Zapisz"}
        </Button>
      </div>

      <div
        id="printable-content"
        style={{
          position: "relative",
          width: pdfWidth,
          height: pdfHeight,
          fontFamily: "VeryBerryPro, Lato-Regular",
          backgroundColor: "#ffffff",
          margin: "auto",
        }}
      >
        {/* Ignacy */}
        <InlineEdit
          value={text1}
          setValue={setText1}
          style={{
            fontSize: `${fontSizeText1}px`,
            fontFamily: font1,
            color: "#98ccc7",
            position: "absolute",
            top: "22.1mm",
            left: "86.4mm",
            width: `${maxWidth1 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            letterSpacing: "0.4px",
            fontVariantLigatures: "no-contextual",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 19.07.2023 */}
        <InlineEdit
          value={text2}
          setValue={setText2}
          style={{
            fontSize: `${fontSizeText2}px`,
            fontFamily: font2,
            color: "#98ccc7",
            position: "absolute",
            top: "211.7mm",
            right: "20.7mm",
            width: `${maxWidth2 + 5}px`,
            textAlign: "right",
            letterSpacing: "-0.6px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* środa */}
        <InlineEdit
          value={text3}
          setValue={setText3}
          style={{
            fontSize: `${fontSizeText3}px`,
            fontFamily: font2,
            color: "#98ccc7",
            position: "absolute",
            top: "225.3mm",
            right: "20.4mm",
            width: `${maxWidth3 + 5}px`,
            textAlign: "right",
            letterSpacing: "0.8px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* godz. 12:20 */}
        <InlineEdit
          value={text4}
          setValue={setText4}
          style={{
            fontSize: `${fontSizeText4}px`,
            fontFamily: font2,
            color: "#98ccc7",
            position: "absolute",
            top: "238.1mm",
            right: "20.8mm",
            width: `${maxWidth4 + 5}px`,
            textAlign: "right",
            letterSpacing: "-0.4px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 56 cm szczęścia */}
        <InlineEdit
          value={text5}
          setValue={setText5}
          style={{
            fontSize: `${fontSizeText5}px`,
            fontFamily: font2,
            color: "#98ccc7",
            position: "absolute",
            top: "250.9mm",
            right: "20.7mm",
            width: `${maxWidth5 + 5}px`,
            textAlign: "right",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 2590 g miłości */}
        <InlineEdit
          value={text6}
          setValue={setText6}
          style={{
            fontSize: `${fontSizeText6}px`,
            fontFamily: font2,
            color: "#98ccc7",
            position: "absolute",
            top: "263.8mm",
            right: "20.8mm",
            width: `${maxWidth6 + 5}px`,
            textAlign: "right",
            letterSpacing: "-0.2px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />

        <img
          src="/images/KD04.svg"
          alt=""
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            top: "0",
            left: "0",
            zIndex: "2",
          }}
        />
      </div>
    </div>
  );
};
